module.exports = __webpack_public_path__ + "img/account-01.8329b8b6.png";